import { SourceHealth, SourceType } from '@mg/shared';
import type { Source } from '@mg/shared';

/** Apify-backed source types use the actor-id locator + JSON actor input. */
export const APIFY_BACKED: ReadonlySet<SourceType> = new Set([
  SourceType.APIFY,
  SourceType.REDDIT,
  SourceType.NEWSLETTER,
]);

/**
 * Whether any of these sources runs through Apify and is failing its pulls. With no Apify key, every
 * such source fails each pull, so it shows up here once its first pull after the key went has failed.
 */
export function hasBreakingApifySources(sources: readonly Source[]): boolean {
  return sources.some(
    (s) =>
      APIFY_BACKED.has(s.type) &&
      (s.health === SourceHealth.DEGRADED || s.health === SourceHealth.FAILING),
  );
}
